import { urls } from 'utils/urls';

import { buildApiRequest } from 'utils/api';

export function getSupplyDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.params.demandId}/supply-details`);
}

export function getOperatorSearchResultsRequest(params) {
  return buildApiRequest(
    'GET',
    `${urls.getOperatorSearch}/?expression=${params.params.expression}&page=${params.params.page}&size=${params.params.size}`,
  );
}

export function updateFreightDetailsRequest(demandId, payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${demandId}/supply-freight`, payload);
}

export function createConsignmenetRequest(payload) {
  return buildApiRequest('POST', `${urls.getConsignments}`, payload);
}

export function updateConsignmentRequest(consignmentId, payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${consignmentId}`, payload);
}

export function getFormConfigRequest() {
  return buildApiRequest('GET', urls.getFormConfig);
}

export function getPhoneNo(params) {
  return buildApiRequest('GET', `${urls.getPhoneNo}?code=${params.code}&codeType=${params.codeType}`);
}